interface MemoryIconProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
  outline?: boolean;
}

export const MemoryIcon = ({ className = "", outline = false, ...props }: MemoryIconProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" className={className} {...props}>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.33203 1.5C3.58313 1.5 2.16536 2.91777 2.16536 4.66667V6.0635C1.65216 6.54953 1.33203 7.23738 1.33203 8C1.33203 8.76262 1.65216 9.45047 2.16536 9.9365V11.3333C2.16536 13.0822 3.58313 14.5 5.33203 14.5C6.45168 14.5 7.43561 13.9189 7.9987 13.0419C8.56179 13.9189 9.54572 14.5 10.6654 14.5C12.4143 14.5 13.832 13.0822 13.832 11.3333V9.9365C14.3452 9.45047 14.6654 8.76262 14.6654 8C14.6654 7.23738 14.3452 6.54953 13.832 6.0635V4.66667C13.832 2.91777 12.4143 1.5 10.6654 1.5C9.54572 1.5 8.56179 2.08108 7.9987 2.95812C7.43561 2.08108 6.45168 1.5 5.33203 1.5ZM5.59883 7.4C5.26746 7.4 4.99883 7.66863 4.99883 8C4.99883 8.33137 5.26746 8.6 5.59883 8.6C6.03037 8.6 6.46681 8.83183 6.81588 9.29726C7.1651 9.76287 7.39883 10.4336 7.39883 11.2C7.39883 11.5314 7.66746 11.8 7.99883 11.8C8.3302 11.8 8.59883 11.5314 8.59883 11.2C8.59883 10.4336 8.83256 9.76287 9.18177 9.29726C9.53085 8.83183 9.96728 8.6 10.3988 8.6C10.7302 8.6 10.9988 8.33137 10.9988 8C10.9988 7.66863 10.7302 7.4 10.3988 7.4C9.50489 7.4 8.74133 7.88452 8.22177 8.57726C8.1423 8.68322 8.06788 8.79473 7.99883 8.91118C7.92978 8.79473 7.85536 8.68322 7.77588 8.57726C7.25633 7.88452 6.49277 7.4 5.59883 7.4Z"
          fill={outline ? "none" : "currentColor"}
          stroke={outline ? "currentColor" : "none"}
          strokeWidth={outline ? "1" : "0"}
        />
      </g>
    </svg>
  );
};
